import { isObject, random } from "lodash-es";
import { Message } from "element-ui";
import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams.js";
import env from "./env";
import request from "@/CommonDP/utils/request";
import JSEncrypt from "jsencrypt";
// 是否忽略菜单权限
const ignorePermissionCheck = false;
const baseStorage = env.VUE_APP_STORAGE === "session" ? sessionStorage : localStorage;
const pathname = /\w+/.test(location.pathname) ? location.pathname : "";
const storagePrefix = env.VUE_APP_MODE === "hash" ? pathname : "";
export const storage = {
  get(key) {
    return baseStorage.getItem(storagePrefix + key);
  },
  set(key, value) {
    return baseStorage.setItem(storagePrefix + key, value);
  },
  remove(key) {
    return baseStorage.removeItem(storagePrefix + key);
  },
  clear() {
    for (let i = 0; i < baseStorage.length; i++) {
      const key = baseStorage.key(i);
      if (key.indexOf(storagePrefix) === 0) {
        baseStorage.removeItem(key);
      }
    }
  }
};
// 后台的接口的 url 地址, 格式为 http://xxx/yyy, 或者 /yyy
export function baseUrl() {
  return env.VUE_APP_HOST + env.VUE_APP_API;
}

export function getContextPath() {
  return env.VUE_APP_API;
}

export function downloadSysReviewPoint() {
  return location.origin + getContextPath() + `/sysReviewPoint/download?token=${getToken()}`;
}

export const STATIC = (env.STATIC_CONTEXT_PATH || "") + "/static";

export function baseUrlWeb() {
  let siteHost = "";
  if (env.VUE_APP_HOST !== "/") {
    siteHost = location.origin;
  } else {
    siteHost = location.origin + env.VUE_APP_SIT_CONTEXT;
  }
  if (env.VUE_APP_MODE === "hash") {
    siteHost += "/#";
  }
  return siteHost;
}

export function Permi() {
  return ignorePermissionCheck;
}

export function getToken() {
  return storage.get("token");
}

export function setToken(token) {
  return storage.set("token", token);
}
export function removeToken() {
  return storage.set("token", "");
}

export function questionImgUrl(prjId, fileMD5) {
  return location.origin + `/bim/doc/v1/wopi/download/drawing?prjId=${prjId}&fileMd5=${fileMD5}&token=${getToken()}`;
}

export function getReadImgFile(filePath) {
  return location.origin + `/bim/doc/v1/upload/` + filePath + "?token=" + getToken();
}

export function downsubway() {
  return location.origin + `/bim/doc/v1/subway/download?token=${getToken()}`;
}
// 文件预览
export function scanUrl(fileId, version) {
  return env.VUE_APP_API + `/wopi/download/file/content?fileId=${fileId}&version=${version}&token=${getToken()}`;
}

export function scanModelUrl(filePath) {
  return location.origin + `/bim/doc/v1/view/${filePath}?token=${token()}`;
}

export function prjImgUploadUrl(filePath) {
  return location.origin + `/bim/doc/v1/upload/${filePath}?token=${getToken()}`;
}

export function scanUrlgml(fileId, docVersionId = "") {
  return location.origin + `/bim/doc/v1/wopi/download/file/content-gml?fileId=${fileId}&docVersionId=${docVersionId}&token=${getToken()}`;
}

export function viewOfficeUrl(fileId) {
  return baseUrl() + `/wopi/getWopiClientUri?fileId=${fileId}&isEdit=false&token=${getToken()}`;
}

export function randomStr(length) {
  // 获取随机字符串
  var list = Array.from({ length }, () => {
    return String.fromCharCode(Math.random() > 0.5 ? random(65, 90) : random(65, 90));
  }).join("");
  return list;
}

export function showPrjName() {
  return new Set(["design"]);
}
// 判断访问来源
export function isMobile() {
  var mobile = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return mobile != null;
}
export function iosQQ() {
  const userAgent = window.navigator.userAgent;
  const iosBrowser = userAgent.indexOf("QBWebView");
  const netType = userAgent.indexOf("NetType");
  return netType > -1 && iosBrowser > -1;
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @description 加载一个script,返回一个Promise对象
 * @param {string|HTMLScriptElement} arg   url
 * @returns {Promise}
 */
export const importScript = async (arg) => {
  const options = { type: "text/javascript", src: "" };
  if (isObject(arg)) {
    Object.assign(options, arg);
  } else {
    options.src = arg;
  }
  return options.src
    ? new Promise((resolve, reject) => {
        let el;
        const src = new URL(options.src, window.location).href;
        // 是否已经加载此js
        const oldScript = document.querySelector(`script[src="${src}"]`);
        if (oldScript) {
          el = oldScript;
        } else {
          el = document.createElement("script");
          Object.assign(el, options);
          document.head.appendChild(el);
        }
        // js加载已完成
        const isloadend = el.dataset.load === "end";
        if (isloadend) {
          resolve();
        } else {
          el.addEventListener("load", () => {
            el.dataset.load = "end";
            resolve();
          });
          el.addEventListener("error", () => {
            document.head.removeChild(el);
            reject();
          });
        }
      })
    : Promise.reject();
};
/**
 * @description importScript的别名,使用网上通用名称
 */
export const loadScript = importScript;
/**
 * @method getServiceURL
 * @param  path {string}  路径参数
 * @param data {any} 路径query传递的参数
 * @param useToken {boolean} 是否添加token
 */

export const getServiceURL = (path = "", data = {}, useToken = true) => {
  const url = new URL(path, new URL(process.env.VUE_APP_API, window.location));
  // 添加用户token
  if (useToken) {
    url.searchParams.append("token", require("@/store/index").default.state.userInfo.token);
  }
  // 添加请求参数
  if (data) {
    for (const key in data) {
      if (Reflect.has(data, key)) {
        url.searchParams.append(key, data[key]);
      }
    }
  }
  return url.href;
};
export function baseApi() {
  return env.VUE_APP_API;
}

export function gentlyUrl(versionId, rvtId, prjId) {
  return baseApi() + `/halo/api/app-doc-center/v1/upload-zip?versionId=${versionId}&rvtId=${rvtId}&prjId=${prjId}&token=${token}`;
}

export const isFirefox = function () {
  return !!window.navigator.userAgent.match(/firefox/i);
};

export const uploadFileFolder = baseApi() + "/doc/chunk";
export const uploadFileFolderNoPermission = baseApi() + "/doc/noPermission/chunk";
// 上传附件地址
export function uploadDataUrl() {
  return baseApi() + `/common/upload`;
}
export function questionImgUrl1(fileMD5) {
  return env.VUE_APP_API + `/pic/preview/${fileMD5}?token=${getToken()}`;
}
// 批注截图预览地址（新）
export function questionImgUrlNew(fileMd5, fileId, fileVersion) {
  return location.origin + getContextPath() + `/pic/newPreview?fileMd5=${fileMd5}&fileId=${fileId || ""}&fileVersion=${fileVersion || 1}&token=${getToken()}`;
}
export function downloadTemplate() {
  return env.VUE_APP_API + `/enterprise/invite/downloadTemplate?token=${getToken()}`;
}
export function downloadTempEnterpriseUser() {
  return env.VUE_APP_API + `/enterprise/inviteEnterpriseUser/downloadTemplate?token=${getToken()}`;
}
export function downStandardLayerTemplate() {
  return env.VUE_APP_API + `/standardLayer/downloadTemplate?token=${getToken()}`;
}
// 文件预览
export function viewFile(filePath, token) {
  return env.VUE_APP_API + `/view/${filePath}?token=${token}`;
}
export function prjplantaskexportexcel(prjId) {
  // 导出
  return env.VUE_APP_API + `/prj-plan-task/export-excel?prjId=${prjId}&token=${getToken()}`;
}
// 获取头像
export function gettouxAvatar(data) {
  return env.VUE_APP_API + `/pic/avatar/${data}?token=${getToken()}`;
}
export function templateDownload() {
  return location.origin + getContextPath() + `/drawingSetPlanEdit/template/download?token=${getToken()}`;
}
// 获取流程图
export function getFlowImage(data) {
  return env.VUE_APP_API + `${data}?token=${getToken()}`;
}
// 获取表单截图
export function getFormImage(data) {
  return env.VUE_APP_API + `${data}?token=${getToken()}`;
}
export function downloadUrlone(fileId) {
  return env.VUE_APP_API + `/download/${fileId}?token=${getToken()}`;
}

export function downloadDesignPrintFile(fileId, fileVersion) {
  return env.VUE_APP_API + `/doc/download/EnterpriseDoc/${fileId}?version=${fileVersion}&token=${getToken()}`;
}

export function downloadUrltoken(prjId, fileId, version) {
  // 自定义接口地址
  const newUrl = globalParams.get("url:/doc/download/${prjId}/${fileId}");
  if (isDef(newUrl)) {
    if (version) {
      return env.VUE_APP_API + `${newUrl}/${prjId}/${fileId}?version=${version}&token=${getToken()}`;
    } else {
      return env.VUE_APP_API + `${newUrl}/${prjId}/${fileId}?token=${getToken()}`;
    }
  }
  if (version) {
    return env.VUE_APP_API + `/doc/download/${prjId}/${fileId}?version=${version}&token=${getToken()}`;
  } else {
    return env.VUE_APP_API + `/doc/download/${prjId}/${fileId}?token=${getToken()}`;
  }
}
export function downloadUrlNoPermissiontoken(prjId, fileId) {
  return env.VUE_APP_API + `/doc/noPermission/download/${prjId}/${fileId}?token=${getToken()}`;
}
// 流程文件下载
export function flowFileDownLoad(flowInstanceId, fileId, fileVersion) {
  return env.VUE_APP_API + `/flow/file/download?flowInstanceId=${flowInstanceId}&fileId=${fileId}&fileVersion=${fileVersion}&token=${getToken()}`;
}
export function downloadUrltokenOne(fileId) {
  return env.VUE_APP_API + `/flow/download/${fileId}?token=${getToken()}`;
}
export function shareDownloadUrl(fileId, version, shareToken) {
  return env.VUE_APP_API + `/doc/shareNew/file/download?fileId=${fileId}&version=${version}&shareToken=${shareToken}`;
}
// app文件预览
export function scanUrlapp(fileId) {
  return env.VUE_APP_API + `/app/download/file/content?fileId=${fileId}`;
}
export function getapptoux(data) {
  return env.VUE_APP_API + `/app/avatar?userId=${data}`;
}
// 反馈统计附件预览
export function feedBackPreviewAccessory(questionID) {
  return env.VUE_APP_API + `/feedback/browse?questionID=${questionID}&token=${getToken()}`;
}
export function downloadUrl(prjId, fileId) {
  // 自定义接口地址
  const newUrl = globalParams.get("url:/doc/download/${prjId}/${fileId}");
  if (isDef(newUrl)) {
    return env.VUE_APP_API + `${newUrl}/${prjId}/${fileId}?token=${getToken()}`;
  }
  return env.VUE_APP_API + `/doc/download/${prjId}/${fileId}?token=${getToken()}`;
}
// 模型缩略图
export function modelThumbnail(fileId, fileVersion) {
  return env.VUE_APP_API + `/light/preview/thumbnail?fileId=${fileId}&fileVersion=${fileVersion}&token=${getToken()}`;
}

// 预览营业执照
export function scanzhizhao(fileId) {
  return env.VUE_APP_API + `/download/${fileId}?token=${getToken()}`;
}

export function downloadUrl2() {
  return env.VUE_APP_API + `/chk-point/downloadTemplate?token=${getToken()}`;
}

export function downloadDesignTemplateUrl(fileId, flowInstanceId) {
  return env.VUE_APP_API + `/doc/downloadFlow/EnterpriseDoc/${fileId}?flowInstanceId=${flowInstanceId}&token=${getToken()}`;
}

export function familyMd5(md5) {
  return env.VUE_APP_API + `/family/new/view/md5?md5=${md5}`;
}
// 获取企业图标
export function getSystemIcon() {
  return env.VUE_APP_API + `/system/getSystemIcon`;
}
// 获取登录页图标
export function getLoginIcon() {
  return env.VUE_APP_API + `/system/getLoginIcon`;
}

// 中心文件备份-下载
export function revitBackUpDownload(fileId, backupFolder, version) {
  return env.VUE_APP_API + `/revitBackUp/download?fileId=${fileId}&backupFolder=${backupFolder}&token=${getToken()}`;
}
// 中心文件备份-下载(回收站文件)
export function revitServerDownload(fileId, version) {
  return env.VUE_APP_API + `/revit-server/download?fileId=${fileId}&token=${getToken()}`;
}
// ISO管理下载
export function isoManageDownload(flowBusinessId) {
  return env.VUE_APP_API + `/isoManage/download?flowBusinessId=${flowBusinessId}&token=${getToken()}`;
}

export function downloadFile(fileUrl) {
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.style.height = 0;
  iframe.src = fileUrl;
  document.body.appendChild(iframe);
  setTimeout(() => {
    iframe.remove();
  }, 5 * 60 * 1000);
}
export function downloadFileShowPrompt(fileName, response) {
  var reader = new FileReader();
  reader.readAsText(response, "utf-8");
  reader.onload = function (e) {
    const msg = reader.result;
    if (msg?.includes("result") && msg?.includes("message")) {
      const msgObj = JSON.parse(msg);
      Message.error(msgObj.message);
    } else {
      if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(response, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = response;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };
}

export function decodeFileName(contentDisposition, rawFilename) {
  let fileName = "";
  if (contentDisposition) {
    // 正则获取filename的值
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, "");
    }
    fileName = decodeURI(escape(fileName));
  } else {
    fileName = decodeURI(escape(rawFilename));
  }
  return fileName;
}

export function uniqueSortedArray(array) {
  if (!array || !array.length) {
    return [];
  }
  let head = 0;
  let tail = 0;
  while (head < array.length) {
    while (++head < array.length && array[head] === array[tail]) {
      continue;
    }
    if (head >= array.length) {
      break;
    }
    array[++tail] = array[head];
  }
  return array.slice(0, tail + 1);
}

export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

export function toQueryString(json) {
  if (!json) return "";
  return cleanArray(
    Object.keys(json).map((key) => {
      if (json[key] === undefined) return "";
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    })
  ).join("&");
}

export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}

export function addParamToUrl(url, paramName, paramValue) {
  url = url || "";
  if (url.includes("?")) {
    return url + "&" + paramName + "=" + paramValue;
  } else {
    return url + "?" + paramName + "=" + paramValue;
  }
}

export function generalRequest(url, type, params, headers) {
  console.log("type = ", type, "url = ", url, headers);
  if (type && typeof type === "string" && type.toLowerCase() === "post") {
    return request.post(url, params, {
      headers
    });
  }
  if (type && type.cnName && type.cnName.toLowerCase() === "post") {
    return request.post(url, params, {
      headers
    });
  }
  console.log(url, params);
  return request.get(url, { params, headers });
}

export function tree2Map(tree) {
  const map = {};
  function traverse(node) {
    (map[node.pid] || (map[node.pid] = [])).push(node);
    if (node.children) {
      node.children.forEach((child) => traverse(child));
    }
  }
  tree.forEach((node) => traverse(node));
  return map;
}
/**
 * @description 调用方法,如果这个方法return回调方法,返回这个回调
 * @param {Function} fn 需要包装的方法,
 * @param  {...any} 后续的参数
 * @returns {Function} 传入方法调用后的回调
 */
export async function wrapCallBack(fn, ...arg) {
  const defFn = new Function();
  if (typeof fn !== "function") return defFn;
  const subFn = await fn.apply(this, arg);
  return subFn || defFn;
}

export function encPwd(data) {
  if (!data) {
    return;
  }
  if (data.startsWith("_XXX_")) {
    return;
  }
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(globalParams.get("login.pwd.encRsaPublicKey", ""));
  const encrypted = encrypt.encrypt(data);
  return globalParams.get("login.pwd.encryptedPwdPrefix", "") + encrypted;
}

export function removeSuffixes(str) {
  const randomNumber = str.split("__").at(-1);
  var reg = new RegExp(`__${randomNumber}`);
  str = str.replace(reg, "");
  return str;
}
